import { render, staticRenderFns } from "./ComparisonCard.vue?vue&type=template&id=02713cc0&scoped=true&"
import script from "./ComparisonCard.vue?vue&type=script&lang=ts&"
export * from "./ComparisonCard.vue?vue&type=script&lang=ts&"
import style0 from "./ComparisonCard.vue?vue&type=style&index=0&id=02713cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02713cc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDataTable,VIcon,VSheet})
